module.exports = __webpack_public_path__ + "static/media/sendBtn.00423ba4.svg";